import { SimpleTransferOrderListPage } from "@/features/simple-transfer-order/pages/SimpleTransferOrderListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/simple-transfer-order/")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["simple_transfer_order.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: SimpleTransferOrderListPage,
});
